module.exports = __webpack_public_path__ + "static/media/Partner17.5514926e.webp";